import React, { useState } from "react";
import Ideadox from "../../logos/Ideadox.svg";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Star from "../../logos/Star.svg";
import { caseStudies } from "../CaseStudy";
import CaseStudyCard from "../CaseStudyCard";
import { isMobile } from "react-device-detect";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";

const CaseStudy2 = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const displayedCaseStudies = caseStudies.slice(0, 3);

  return (
    <div
      style={{
        backgroundColor: "#F0DFD8",
        padding: "2rem",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        overflowX: "hidden",
        overflow: "hidden",
      }}
    >
      <header
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          padding: "1rem",
          boxSizing: "border-box",
          top: 5,
          position: "absolute",
        }}
      >
        <div
          onClick={() => navigate("/caseStudy")}
          style={{ cursor: "pointer" }}
        >
          <img src={Ideadox} alt="Ideadox" />
        </div>
        {isMobile ? (
          <div>
            <Button
              className="border border-black mt-2 rounded-full"
              onClick={handleMenuOpen}
            >
              <MenuIcon />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent white
                  boxShadow: "none",
                },
              }}
            >
              <MenuItem
                onClick={handleMenuClose}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                Blog
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/caseStudy")}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                Case Study
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/aboutus")}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                About
              </MenuItem>
            </Menu>
            <button className="border border-black py-1 px-2 mt-2 rounded-full hover:bg-black hover:text-white">
              Get In Touch
            </button>
          </div>
        ) : (
          <nav className="space-x-4 mr-4">
            <button
              className="hover:underline"
              onClick={() => {
                /* handle click */
              }}
            >
              Blog
            </button>
            <button
              className="hover:underline"
              onClick={() => {
                navigate("/caseStudy");
              }}
            >
              Case Study
            </button>
            <button
              className="hover:underline"
              onClick={() => navigate("/aboutus")}
            >
              About
            </button>
            <button className="border border-black py-1 px-3 rounded-full hover:bg-black hover:text-white">
              Get In Touch
            </button>
          </nav>
        )}
      </header>
      <Typography
        style={{
          fontFamily: "Bricolage Grotesque",
          fontWeight: 600,
          fontSize: isMobile ? "24px" : "48px", // Adjust font size for mobile
          color: "#2F2F30",
          lineHeight: isMobile ? "30px" : "65px", // Adjust line height for mobile
          textAlign: "left",
          marginTop: isMobile ? "80px" : "70px", // Adjust margin for mobile
          maxWidth: isMobile ? "100%" : "50%", // Adjust width for mobile
          overflowWrap: "break-word",
        }}
      >
        Modernizing Development Practices for Enhanced Product Quality
      </Typography>
      <div
        className={`flex flex-col items-start px-8 ${
          isMobile ? "mt-6" : "mt-2"
        }`}
        style={{
          marginRight: isMobile ? "50%" : "40%",
        }}
      >
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
          }}
        >
          Background
        </Typography>
      </div>
      <div>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 350,
            fontSize: isMobile ? "20px" : "20px",
            color: "#78787A",
            width: isMobile ? "110%" : "741px",
            marginTop: "10px",
            marginLeft: isMobile ? "-2%" : "",
            textAlign: "left",
          }}
        >
          Client B had a development team that lacked modern tooling and
          structured processes, resulting in a product plagued with bugs and
          inefficiencies. The absence of agile methodologies and a centralized
          development process led to disorganization and incomplete features.
        </Typography>
      </div>
      <div
        className="flex flex-col items-start mt-2"
        style={{
          marginRight: isMobile ? "16%" : "9%", // Further reduce margin for mobile
          width: isMobile ? "90%" : "40%", // Increase width for mobile
          overflowWrap: "break-word", // Ensure text wraps properly
        }}
      >
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
          }}
        >
          Challenges
        </Typography>
        <div className="mt-4">
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontWeight: 350,
              fontSize: isMobile ? "20px" : "20px",
              color: "#78787A",
              textAlign: "left",
              width: isMobile ? "45%" : "800px", // Ensure it takes full width
              overflowWrap: "break-word", // Ensure text wraps properly
            }}
          >
            • Outdated technology stack and tools hindered efficiency..
          </Typography>
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontWeight: 350,
              fontSize: isMobile ? "20px" : "20px",
              color: "#78787A",
              textAlign: "left",
              width: isMobile ? "45%" : "800px", // Ensure it takes full width
              overflowWrap: "break-word", // Ensure text wraps properly
            }}
          >
            • Unstructured development process with a lack of agile frameworks
            led to delays and misunderstandings
          </Typography>
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontWeight: 350,
              fontSize: isMobile ? "20px" : "20px",
              color: "#78787A",
              textAlign: "left",
              overflowWrap: "break-word", // Ensure text wraps properly
              width: "800px",
            }}
          >
            • Frequent bugs due to minimal <br />
            testing and code review protocols.
          </Typography>
        </div>
      </div>
      {!isMobile && (
        <div className="fixed top-28 left-20 h-1/2 w-64 p-2">
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontSize: "22px",
              fontWeight: 600,
              color: "#2F2F30",
              textAlign: "left",
            }}
          >
            CONTENTS
          </Typography>
          <ul>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                Background
              </Typography>
            </li>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                Challenges
              </Typography>
            </li>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                CTO Solution
              </Typography>
              <li>
                <Typography
                  align="left"
                  style={{
                    marginTop: "8px",
                    fontFamily: "Golos Text",
                    fontSize: "20px",
                    fontWeight: 400,
                    color: "#78787A",
                  }}
                >
                  Upgraded Technology Stack:
                </Typography>
              </li>
              <li>
                <Typography
                  align="left"
                  style={{
                    marginTop: "8px",
                    fontFamily: "Golos Text",
                    fontSize: "20px",
                    fontWeight: 400,
                    color: "#78787A",
                  }}
                >
                  Implementation of Agile Frameworks
                </Typography>
              </li>
              <li>
                <Typography
                  align="left"
                  style={{
                    marginTop: "8px",
                    fontFamily: "Golos Text",
                    fontSize: "20px",
                    fontWeight: 400,
                    color: "#78787A",
                  }}
                >
                  Quality Assurance Practices
                </Typography>
              </li>
            </li>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                Impact
              </Typography>
            </li>
          </ul>
        </div>
      )}
      <div
        className="flex flex-col items-start mt-2"
        style={{
          marginRight: isMobile ? "45%" : "9%",
          width: isMobile ? "60%" : "40%",
        }}
      >
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
          }}
        >
          CTO Solution
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "170%" : "850px",
          }}
        >
          As the acting CTO for Client B, IDEADOX led the team in a
          comprehensive transformation to boost technical efficiency.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Upgraded Technology Stack
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          We conducted a thorough assessment of the existing stack and
          identified tools to modernize development. This included introducing
          robust version control, CI/CD pipelines, and automating testing,
          reducing human error and manual testing time
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Implementation of Agile Frameworks
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          We introduced an agile workflow, including sprint planning, daily
          stand-ups, and retrospectives. This brought structure to development
          cycles and enabled continuous delivery
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Quality Assurance Practices
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          Instituted a mandatory code review process and introduced automated
          unit and integration tests to catch bugs early. This included
          performance monitoring and issue tracking systems to proactively
          identify and address problems
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
          }}
        >
          Impact
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          • 70% decrease in bug reports, leading to smoother releases.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          • improved developer efficiency with shorter development cycles and
          faster{" "}
          <span
            style={{
              marginLeft: "12px",
            }}
          >
            {" "}
            delivery of features.
          </span>
        </Typography>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // Center horizontally
            marginTop: "60px",
            width: isMobile ? "160%" : "140%", // Ensure it takes full width
          }}
        >
          <img src={Star} alt="Star" style={{ marginRight: "0.5rem" }} />
          <Typography
            style={{
              fontSize: 28,
              fontFamily: "Bricolage Grotesque",
              fontWeight: 200,
              color: "#2F2F30",
            }}
          >
            Case Study
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Center horizontally
            width: "140%", // Ensure it takes full width
          }}
        >
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontSize: isMobile ? "26px" : "34px",
              fontWeight: 600,
              textAlign: "center",
              marginTop: "40px",
              marginLeft: isMobile ? "17%" : "",
            }}
          >
            Read More
          </Typography>
        </div>
        <div
          className="case-studies-list"
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "40px",
            marginTop: "20px",
            flexDirection: isMobile ? "column" : "row", // Change direction for mobile
            alignItems: isMobile ? "center" : "flex-start", // Center items on mobile
            marginLeft: isMobile ? "12%" : "",
          }}
        >
          {displayedCaseStudies.map((study, index) => (
            <div
              key={index}
              style={{
                width: "300px", // Set a consistent width
                padding: "16px",
              }}
            >
              <CaseStudyCard
                title={study.title}
                link={study.link}
                image={study.image}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseStudy2;
